// bm-design-system: segmented-control primitive (ported from FloorCore)
// Pill-track step/tab switcher: active segment lifts to a white card.
import * as React from "react";
import { cn } from "@/lib/utils";

export interface SegmentOption {
  value: string;
  label: React.ReactNode;
}

export interface SegmentedControlProps {
  options: SegmentOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function SegmentedControl({ options, value, onChange, className }: SegmentedControlProps) {
  return (
    <div
      role="tablist"
      className={cn("inline-flex gap-1 rounded-md bg-surface border border-hairline p-1", className)}
    >
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(o.value)}
            className={cn(
              "cursor-pointer rounded-[8px] px-3.5 py-1.5 font-display text-sm font-semibold transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
              active
                ? "bg-page text-ink-display shadow-sm"
                : "text-ink-muted hover:text-ink-display",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
